<template>
  <div class="page-query">
    <TableQuery title="合同查询" @search="queryData" @reset="reset">
      <el-form inline class="form" size="medium" label-width="100px">
        <el-row :gutter="18">
          <el-col v-for="item in 7" :key="item" :span="8">
            <el-form-item label="合同名称">
              <el-select size="medium" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <div class="table-container">
      <TableCommon
        title="明细"
        export-all
        export-page
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
        @exportExcel="exportExcel"
      >
        <template #button>
          <table-button name="delete" tip="重置" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="medium"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template
            v-for="item in gridOptions.columns"
            #[item.field]="{ row }"
          >
            <div :key="item.field">
              <el-select v-model="row[item.field]" size="small" />
            </div>
          </template>
          <!-- <template #toolbar /> -->
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50, align: 'center' },
          { field: 'PRODUCT_ID', title: '产品标识', width: 180, slots: { default: 'PRODUCT_ID' }},
          { field: 'SHORT_TEXT', title: '产品描述', width: 180 },
          { field: 'ZSALESUNIT', title: '营销单元', width: 180 },
          { field: 'PARTNER', title: '客户编号', width: 180 },
          { field: 'ZPRIC_TYPE', title: '价格类型', width: 180 },
          { field: 'KBETR', title: '价格金额', width: 180 },
          { field: 'RELEASE_STATUS', title: '发布状态', width: 180 },
          { field: 'ZINDEX', title: '生效节点', width: 180 },
          { field: 'TIMESTAMP_FROM', title: '有效日期起', width: 180 },
          { field: 'TIMESTAMP_TO', title: '有效日期截止', width: 180 }
        ],
        data: []
      },
      pagination: {
        page: 1,
        pagesize: 10,
        totalCount: 100
      }
    }
  },
  created() {
    for (let i = 0; i < 50; i++) {
      this.gridOptions.data.push({
        PRODUCT_ID: i + 'jsdlj3829kdsljfncxjkvldjslfmnm,xnfdsj'
      })
    }
  },
  methods: {
    exportExcel(type) {},
    handleTablePaginationChange() {},
    toDetail() {
      this.$router.push('/test/detail')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/Test.vue